var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"message",class:{
    message_error: _vm.type === 'error',
    message_warning: _vm.type === 'warning',
    message_success: _vm.type === 'success',
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }